export const ANDROID = 'android';
export const IOS = 'ios';
export const HUAWEI = 'huawei';
export const STATE = {
  ENABLED: 'enabled',
  HOVER: 'hover',
  FOCUSED: 'focused',
  PRESSED: 'pressed',
  LOADING: 'loading',
  DISABLED: 'disabled',
  SELECTED: 'selected',
  IDLE: 'idle',
  ACTIVE: 'active',
  ERROR: 'error',
};
export const vendorItemVariants = {
  headerOn: 'header-on',
  headerOff: 'header-off',
};

export const PAGE_LOADED_EVENT = 'PAGE_LOADED';

export const DH_IMAGES =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/products/';
export const URL_VENDOR =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/restaurants/';

export const URL_EMPTY_FILTERS =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/deals-navigations/generic-images/Burger.png';

export const URL_EMPTY_FILTERS_REVAMP = 'burgerDisabled1Small';

export const COUNTRY_DISCOUNT_TAGS = {
  1: 'OFF',
  2: 'DCTO.',
  3: 'OFF',
  7: 'DSCTO.',
  13: 'DSCTO.',
  15: 'OFF',
};

export const occasionTypes = {
  delivery: 'delivery',
  pickup: 'pickup',
};

export const deliveryETAVariants = {
  default: 'default',
  quick: 'quick',
  delay: 'delay',
};

export const deliveryFeeVariants = {
  default: 'default',
  free: 'free',
  variable: 'variable',
  'plus-free': 'plus-free',
  'plus-discount': 'plus-discount',
};

export const filtersUtils = {
  DISCOUNT: 'WITH_DISCOUNT',
  DELIVERY_FREE: 'DELIVERY_FREE',
  BUSINESS_TYPE: 'BUSINESS_TYPE',
  DISH_MAIN_CUISINE: 'DISH_MAIN_CUISINE',
  MIN_PRICE: 'MIN_PRICE',
  MAX_PRICE: 'MAX_PRICE',
};

export const tagCategory = {
  DEALS_AND_DISCOUNTS: 'deals-and-discounts',
  POSITIVE: 'positive',
  PEDIDOS_YA: 'pedidos-ya',
};

export const ENTER_KEY_VALUE = 'Enter';

const BASE_DEEPLINK = 'pedidosya://';

export const getDeeplinkShopDetail = (id, occasion) =>
  `${BASE_DEEPLINK}shop_detail/${id}?origin=generic-landing&occasion=${occasion}`;

export const PICK_UP = 'PICK_UP';

export const QC_VENDOR_ITEM = 'QC_VENDOR_ITEM';

export const GLOBAL_HEADERS = {
  TRACE_ID: 'Peya-Trace-ID',
};
